module.exports = __webpack_public_path__ + "img/close.a8609edf.svg";